import { call, put } from 'redux-saga/effects';

import { requestFailed } from '~src/bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '~src/codegen/Localize';
import { IToastOptions, ToasterService, ToastType } from '~src/commonInfra/services/ToasterService';
import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';
import { PublishToSalesforceAction } from '~src/spacesPlatform/actions/PublishToSalesforceActions';

import { open } from '../components/PublishToSalesforceDialog';
import { PublishToSalesforceTelemetryParams, sendExistingCredentialsDialogTelemetry, sendNoCredentialsDialogTelemetry } from '../telemetry/PublishToSalesforceTelemetry';

export function* handlePublishToSalesforceAction(action: PublishToSalesforceAction) {
  try {
    yield call(openPublishToSalesforceDialog, action);
  } catch (e) {
    yield put(requestFailed(e, 'error'));
    PublishToSalesforceTelemetryParams.closePublishDialogParams.existing_credentials_dialog_cancelled = true;

    if (PublishToSalesforceTelemetryParams.closePublishDialogParams.is_existing_credentials_dialog) {
      sendExistingCredentialsDialogTelemetry(PublishToSalesforceTelemetryParams.closePublishDialogParams);
      if (PublishToSalesforceTelemetryParams.closePublishDialogParams.clicked_publish) {
        const toaster = ToasterService.instance;
        const toastOps: IToastOptions = {
          type: ToastType.Info,
          text: Messages.publishToSalesforceDialogClosedWithPublishPending({ ITEM_COUNT: action.content.length }),
          testId: 'publish-to-salesforce-info'
        };
        toaster.pop(toastOps);
      }
    } else {
      sendNoCredentialsDialogTelemetry(PublishToSalesforceTelemetryParams.closePublishDialogParams);
    }
  }
}

export function openPublishToSalesforceDialog(action: PublishToSalesforceAction) {
  const sessionManagementService = getSessionManagementServiceInstance();
  let modalInstance = open(action.content, sessionManagementService);
  return modalInstance;
}
